import React, { useState } from 'react';

export default function ToggleSwitch({value,handleInputChange}) {
  const [enabled, setEnabled] = useState(false);

  return (
    <label className="inline-flex items-center cursor-pointer gap-2 text-sm font-medium text-gray-700 mb-2 group-hover:text-[#174540] transition-colors duration-200">
                Active

    <input
      type="checkbox"
      name={'active'}
      checked={value}
      onChange={(e) =>
        handleInputChange({
          target: {
            name: e.target.name,
            value: e.target.checked,
          },
        })
      }
      className="sr-only"
    />
    <span
      className={`w-11 h-6 flex items-center bg-gray-300 rounded-full p-1 transition-colors duration-300 ${
        value ? 'bg-emerald-600' : 'bg-gray-300'
      }`}
    >
      <span
        className={`bg-white w-4 h-4 rounded-full transform transition-transform duration-300 ${
          value ? 'translate-x-5' : 'translate-x-0'
        }`}
      />
    </span>
  </label>
  );
}